// extracted by mini-css-extract-plugin
export var checked = "msm-video-player-module--checked--7269e";
export var controls = "msm-video-player-module--controls--10406";
export var controlsRow = "msm-video-player-module--controlsRow--0f9a5";
export var fullscreenBtn = "msm-video-player-module--fullscreenBtn--378d6";
export var overlay = "msm-video-player-module--overlay--01da6";
export var progressInput = "msm-video-player-module--progressInput--0c5b0";
export var unchecked = "msm-video-player-module--unchecked--fd9d1";
export var videoTitle = "msm-video-player-module--videoTitle--9a2d1";
export var volumeSlider = "msm-video-player-module--volumeSlider--d78ae";